import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { imageStyles } from '../HowItWorks.style';
import { type HowItWorksProps } from '..';

export const HOW_IT_WORKS_CONTENT: HowItWorksProps = {
  title: 'How it works',
  subtitle:
    'No bots or algorithms here. We get to know you, your skin, and goals.',
  steps: ['Skin quiz', 'Provider review', 'Get your formula', 'Track progress'],
  media: (
    <StaticImage
      src="./images/howItWorks@2x.jpg"
      alt="Close up of woman with a thin layer of The Cleanser lathered on her face"
      objectPosition="center"
      css={imageStyles}
    />
  ),
  ctaText: 'Get the details',
};
